import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
/** Services Import */
import Global from '../../Services/Common/Global';
import Commons from '../../Services/Common/Common';

/** Components */
import { Loading, Dialog } from '../../Components/MUIs';
import { Box, IconButton, Typography } from '@mui/material';
/** Icons Import */
import { Close as CloseIcon } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../Reducer/SnackbarReducer';
import { BaseInfoActions } from '../../Reducer/BaseInfoReducer';
import { initFcm } from '../../firebase';
import { App as CapacitorApp } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import FindPw from './FindPw';
import SignUp from './SignUp';
import Login from './Login';
import IdentityConfirm from './IdentityConfirm';
import {
  MOK_SIGNUP_RESULT_KEY,
  MOK_SIGNUP_CONTEXT_KEY,
  MOK_LOGIN_RESULT_KEY,
  MOK_FINDPW_RESULT_KEY,
  MOK_IDENTITY_USER_KEY,
} from './IdentityMokCallback';
import { Login_Schema } from './Login_Schema';
import { createInitial } from '../../util';
import { useSchemaValidation } from '../../Hooks/useSchema';
import { CodeInfoActions } from '../../Reducer/CodeInfoReducer';
import { CommonActions } from '../../Reducer/CommonReducer';
import { useBackHandler } from '../../Hooks/back/useBackHandler';

const INTERNAL_MENU = [
  'M_TBMManager',
  'M_TBM',
  'M_Permit',
  'M_TRA',
  'M_TRA_SIGN',
  'M_EmergencyTel',
  'M_WorkStop/write',
  'M_WorkStop',
];

function LoginFunction() {
  const { state } = useLocation();
  const dispatch = useDispatch();
  const { statusBar, navBar } = useSelector((state) => state.systemBar);
  const { riskWorkerOpinionMenuActive } = useSelector(
    (state) => state.homeInfo
  );
  const [loading, setLoading] = useState(false);
  const [dialog, setDialog] = useState({
    open: false,
    title: '',
    content: null,
    type: '',
  }); // 팝업 객체

  const navigate = useNavigate();
  const [inputs, setInputs] = useState({
    userId: Commons.Storages('get', 'settings').userIdKeep
      ? Commons.Storages('get', 'settings').userId
      : '', // user id
    userPw: '', // user password
    passwordVisible: false, // 패스워드 보기 버튼 토글
    lanCd: Commons.Storages('get', 'settings').lanCd
      ? Commons.Storages('get', 'settings').lanCd
      : '', // 언어 선택 콤보 선택 값 저장하는 변수
    userIdKeep: Commons.Storages('get', 'settings').userIdKeep, // 아이디 저장 값 저장 변수
    loginKeep: Commons.Storages('get', 'settings').loginKeep, // 자동 로그인 값 저장 변수
  });
  const [deferredPrompt, setDeferredPrompt] = React.useState(null); // 앱 설치 prompt를 담는 변수
  const [lanCdList, setLanCdList] = useState([]); // Language Combobox list
  const [lanList, setLanList] = useState([]); // Language list
  const [codeList, setCodeList] = useState([]); // code list
  const [findPwInputs, setFindPwInputs] = useState(() =>
    createInitial(Login_Schema.fields.findPwForm)
  );
  const [signUpInputs, setSignUpInputs] = useState(() =>
    createInitial(Login_Schema.fields.signUpForm)
  );
  const [agreement, setAgreement] = useState(() =>
    createInitial(Login_Schema.fields.agreement)
  );
  const [listOptions, setListOptions] = useState(() =>
    createInitial(Login_Schema.lists)
  );
  const [authGroups, setAuthGroups] = useState([]); // 관리자 권한 목록 저장 변수
  const [regions, setRegions] = useState([]); // 지역 목록 저장 변수
  const [siteList, setSiteList] = useState([]); // 현장별 지역 목록
  const [siteManagerSite, setSiteManagerSite] = useState(''); // 현장 관리자가 선택한 현장 AutoComplete 저장 변수
  const [siteManagerSiteInput, setSiteManagerSiteInput] = useState(''); // 현장 관리자가 선택한 현장 AutoComplete 저장 변수
  const [custList, setCustList] = useState([]); // 사업체 목록
  const [headManagerSite, setHeadManagerSite] = useState(''); // 본사 관리자가 선택한 사업체 AutoComplete 저장 변수
  const [headManagerSiteInput, setHeadManagerSiteInput] = useState(''); // 본사 관리자가 선택한 사업체 AutoComplete 저장 변수
  const [deptOptions, setDeptOptions] = useState([]); // 부서 목록
  const [signupCompanyOptions, setSignupCompanyOptions] = useState([]); // 회원가입 회사 목록
  const [signupSiteOptions, setSignupSiteOptions] = useState([]); // 회원가입 사업장 목록
  const [modalToggle1, setModalToggle1] = useState(false); // 전자서명 팝업창
  const [workSignature, setWorkSignature] = useState(''); // 전자서명 string
  const [sign, setSign] = React.useState(0);
  const [imageFile, setImageFile] = React.useState({
    mapFiles: '', //파일 String
    mapFileName: '', //파일이름
  });
  const [capsLockFlag, setCapsLockFlag] = useState(false);
  const [confirmId, setConfirmId] = useState(true);
  const [confirmPw, setConfirmPw] = useState(true);
  const [signUpId, setSignUpId] = useState(true);
  const custRef = useRef();
  const [backClick, setBackClick] = useState(null);
  const { validateRequiredWithMessage } = useSchemaValidation();
  // 뒤로가기 핸들러 설정
  // SignUp 모달이 열려있을 때는 SignUp 컴포넌트의 useBackHandler가 동작하므로 비활성화
  useBackHandler({
    backClick: dialog.open && dialog.type === 'SignUp' ? null : backClick,
    setBackClick,
    redirectPath: null,
    setRedirectPath: () => {},
    sheetTypeRef: null,
  });

  // 뒤로가기 동작 설정
  useEffect(() => {
    if (dialog.open && dialog.type === 'FindPw') {
      setBackClick({
        fn: () => CloseDialog(),
        clearAfter: true,
      });
      return;
    }
    if (!dialog.open) {
      // 다이어로그가 없을때만 로그인 화면에서 뒤로가기 시 앱 종료 확인
      setBackClick({
        fn: () => {
          if (Capacitor.getPlatform() === 'android') {
            if (window.confirm('앱을 종료하시겠습니까?')) {
              CapacitorApp.exitApp();
            }
          }
        },
        clearAfter: false,
      });
    }
  }, [dialog]);

  // 홈 화면에 바로가기 추가를 위해 beforeinstallprompt 이벤트 등록
  useEffect(() => {
    window.addEventListener(
      'beforeinstallprompt',
      HandleBeforeInstallPrompt // 사용자가 해당 앱을 설치하지 않았을 경우에만 발생하는 리스너.
    );
    return () => {
      window.removeEventListener(
        'beforeinstallprompt',
        HandleBeforeInstallPrompt
      );
    };
  }, []);

  useEffect(() => {
    // 본인확인 redirect 콜백 후 복귀: 결과가 있으면 SignUp 다이얼로그만 열기
    const stored = sessionStorage.getItem(MOK_SIGNUP_RESULT_KEY);
    if (stored) {
      try {
        JSON.parse(stored);
        setDialog({
          open: true,
          title: '',
          content: null,
          type: 'SignUp',
        });
      } catch (_) {
        sessionStorage.removeItem(MOK_SIGNUP_RESULT_KEY);
      }
    }

    // 본인인증(로그인 후) redirect 콜백 후 복귀: identityConfirm 다이얼로그 열기
    const identityStored = sessionStorage.getItem(MOK_LOGIN_RESULT_KEY);
    if (identityStored) {
      try {
        JSON.parse(identityStored);
        setDialog({
          open: true,
          title: '본인인증',
          content: null,
          type: 'identityConfirm',
        });
      } catch (_) {
        sessionStorage.removeItem(MOK_LOGIN_RESULT_KEY);
      }
    }

    // 비밀번호 찾기 본인인증 redirect 콜백 후 복귀
    const findPwStored = sessionStorage.getItem(MOK_FINDPW_RESULT_KEY);
    if (findPwStored) {
      try {
        JSON.parse(findPwStored);
        setDialog({
          open: true,
          title: '',
          content: null,
          type: 'FindPw',
        });
      } catch (_) {
        sessionStorage.removeItem(MOK_FINDPW_RESULT_KEY);
      }
    }

    Init();

    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', preventGoBack);
    return () => {
      window.removeEventListener('popstate', preventGoBack);
    };
  }, []);

  useEffect(() => {
    if (
      agreement.serviceUsingCheck &&
      agreement.personalInformationCheck &&
      agreement.disclaimerCheck &&
      agreement.serviceKindCheck &&
      agreement.transferAndCompensationCheck
    ) {
      setAgreement((prev) => ({
        ...prev,
        allAgreeCheck: true,
      }));
    } else {
      setAgreement((prev) => ({
        ...prev,
        allAgreeCheck: false,
      }));
    }
  }, [
    agreement.serviceUsingCheck,
    agreement.personalInformationCheck,
    agreement.disclaimerCheck,
    agreement.serviceKindCheck,
    agreement.transferAndCompensationCheck,
  ]);

  const Init = async () => {
    setLoading(true);
    let lanCodeData = [];
    let lanData = [];
    let codeData = [];
    let userTypeData = [];
    let bloodData = [];
    let authData = [];
    let regionData = [];
    let nationData = [];
    let careerData = [
      {
        name: '근무경력을 선택하세요.',
        value: '0',
      },
    ];

    try {
      if (state?.versionYn === 'Y') {
        dispatch(
          showSnackbar({
            message: '업데이트가 되어 로그아웃됩니다.',
            type: 'warning',
          })
        );
      }

      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Account.getLanguage,
        {
          LanguageCode: Commons.EncryptAES(inputs.lanCd ? inputs.lanCd : 'kr'),
        }
      ).then((result) => {
        let data = result.data;
        // console.log('init data: ', data);

        if (data.type === 'Error') {
          throw new Error(data.message);
        } else {
          if (data.lanList.length > 0) {
            data.lanList.forEach((item, index) => {
              lanData.push(item);
            });
          }
          if (data.lanCode.length > 0) {
            data.lanCode
              .filter((e) => e.groupCd === 'CAREER_PERIOD')
              .sort((a, b) => parseInt(a.ref1) - parseInt(b.ref1))
              .forEach((_item) => {
                careerData.push({
                  name: _item.codeNm,
                  value: _item.code,
                });
              });
          }
          if (data.lanCode.length > 0 && data.lanList.length > 0) {
            data.lanCode.forEach((item, index) => {
              codeData.push(item);
              if (item.groupCd === 'LAN_CD') {
                lanCodeData.push({
                  name: item.codeNm,
                  value: item.code,
                });
              } else if (item.groupCd === 'USER_TYPE') {
                userTypeData.push({
                  name: item.codeNm,
                  value: item.code,
                });
              } else if (item.groupCd === 'BloodType') {
                bloodData.push({
                  name: item.codeNm,
                  value: item.code,
                });
              } else if (item.groupCd === 'AUTH' && item.val1 !== '0') {
                authData.push({
                  name: item.codeNm,
                  value: item.code,
                  seq: item.val1,
                });
              } else if (item.groupCd === 'REGION' && item.code !== 'REGION') {
                regionData.push({
                  name: item.codeNm,
                  value: item.code,
                });
              } else if (item.groupCd === 'NATION') {
                nationData.push({
                  name: item.codeNm,
                  value: item.code,
                });
              }
            });
          } else {
            throw new Error('Data abnormality!');
          }

          setLanCdList(lanCodeData);
          setLanList(lanData);
          dispatch(CodeInfoActions.setCodeInfo(codeData));
          setAuthGroups(
            authData
              .filter((e) => e.value !== 'ADMIN')
              .sort((a, b) => b.seq - a.seq)
          );
          setRegions(regionData);

          setListOptions({
            userTypeList: userTypeData.reverse(),
            bloodList: bloodData,
            nationList: nationData,
            careerList: careerData,
          });
        }
      });
    } catch (e) {
      console.log('Error: ', e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: 'error',
        })
      );
    } finally {
      setLoading(false);
    }
  };

  const preventGoBack = () => {
    window.history.pushState(null, '', window.location.href);
  };

  // Checkbox 선택 로직 함수
  const ChangeCheckbox = (_type, _data) => {
    if (_type === 'id') {
      setInputs({
        ...inputs,
        userIdKeep: _data,
      });
      const settings = Commons.Storages('get', 'settings');
      Commons.Storages('set', 'settings', {
        ...settings,
        userIdKeep: _data,
        // 체크박스를 체크하면 현재 입력된 아이디를 저장하고, 해제하면 아이디를 삭제
        userId: _data ? inputs.userId : '',
      });
    } else if (_type === 'account') {
      setInputs({
        ...inputs,
        loginKeep: _data,
      });
      Commons.Storages('set', 'settings', {
        ...Commons.Storages('get', 'settings'),
        loginKeep: _data,
      });
    }
  };

  // Group button을 누를 때 어떤 Dialog를 뿌릴지 결정하는 함수
  const DialogLogic = (_type) => {
    switch (_type) {
      case 'FindPw':
        return setDialog({
          ...dialog,
          open: true,
          title: '',
          content: null,
          type: _type,
        });
      case 'SignUp':
        return setDialog({
          ...dialog,
          open: true,
          title:
            lanList.length > 0
              ? lanList.filter((f) => f.lanId === 'SignUp')[0].lanNm
              : '', // 회원가입
          content: null,
          type: _type,
        });
    }
  };

  // 로그인 예외처리 함수
  const LoginValidation = () => {
    if (!inputs.userId) {
      setConfirmId(false);
      dispatch(
        showSnackbar({
          message: lanList.filter((f) => f.lanId === 'PleaseCheckYourId')[0]
            .lanNm,
          type: 'error',
        })
      );

      return false;
    } else if (!inputs.userPw) {
      setConfirmPw(false);
      dispatch(
        showSnackbar({
          message: lanList.filter(
            (f) => f.lanId === 'PleaseCheckYourPassword'
          )[0].lanNm,
          type: 'error',
        })
      );
      return false;
    } else {
      return true;
    }
  };

  // 로그인 함수
  const LoginLogic = async () => {
    setLoading(true);

    if (!LoginValidation()) {
      setLoading(false);
      return false;
    }

    let userInfo = [];
    let menuInfo = [];
    let lanInfo = [];
    let custInfo = [];
    let companyInfo = [];

    try {
      sessionStorage.setItem(MOK_IDENTITY_USER_KEY, inputs.userId);
      const fcmResult = await initFcm();
      const firebaseToken = fcmResult?.token || '';

      await Commons.Axios(
        'login',
        Global.base.useUrl + Global.urls.Account.login,
        {
          value2: Commons.EncryptAES(inputs.userId),
          value3: Commons.EncryptAES(inputs.userPw),
          keep: inputs.loginKeep,
          value1: Commons.EncryptAES(inputs.lanCd),
          value4: Commons.EncryptAES(firebaseToken),
          value5: Commons.EncryptAES(Commons.IsMobile() ? 'Y' : 'N'),
          value6: Commons.EncryptAES(Commons.DeviceCheck()),
        }
      ).then(async (result) => {
        const data = result.data;

        if (data.type === 'Error') {
          throw new Error(data.message);
        }
        // 계약 기간: 일(날짜) 단위만 비교
        const today = dayjs().startOf('day');
        const contractStart = dayjs(
          data.companyInfo[0].contractStartDate
        ).startOf('day');
        const contractEnd = dayjs(data.companyInfo[0].contractEndDate).startOf(
          'day'
        );
        if (
          today.isBefore(contractStart, 'day') ||
          today.isAfter(contractEnd, 'day')
        ) {
          dispatch(
            showSnackbar({
              message: '계약 기간이 아닙니다. 계약 기간을 확인해주세요.',
              type: 'warning',
            })
          );
          return false;
        }

        // 본인인증 여부 체크(userInfo.ci)
        if (!data.userInfo.ci) {
          setDialog({
            ...dialog,
            open: true,
            title: '본인인증',
            type: 'identityConfirm',
          });
          return false;
        }

        Commons.Storages('set', 'aiCallState', {
          startYn: 'N',
          workYn: 'N',
        });

        Commons.Storages('set', 'settings', {
          ...Commons.Storages('get', 'settings'),
          userId: inputs.userIdKeep ? inputs.userId : '',
          userNm: data.userInfo.userNm,
        });

        userInfo.push(data.userInfo);
        // GetInfo 후 Redux에 userInfo 저장 (후속 화면/API에서 사용)
        dispatch(BaseInfoActions.setUserInfo(userInfo[0]));

        menuInfo = data.menuInfo
          .filter((m) => String(m.screenType) === '1')
          .map((item) => {
            const menu = { ...item, open: false };

            if (['M_WorkEnd2'].includes(item.menuId)) {
              menu.requiresWorkCd = true;
            }

            if (['M_PPE', 'M_TBMManager', 'M_TBM'].includes(item.menuId)) {
              menu.hideWhenWorking = true;
            }

            return menu;
          });

        // 근로자 의견 메뉴 활성화 여부가 true면 M_RNM, false면 M_WorkInfo 추가
        menuInfo = menuInfo.filter((m) => {
          if (m.menuId === 'M_RNM') return riskWorkerOpinionMenuActive;
          if (m.menuId === 'M_WorkInfo') return !riskWorkerOpinionMenuActive;
          return true;
        });
        // 비상연락망(emtYn)에 따른 작업중지 메뉴 필터 (Layout.js와 동일)
        const isEmtUser =
          String(data.userInfo?.emtYn ?? '').toUpperCase() === 'Y';
        if (isEmtUser) {
          menuInfo = menuInfo.filter((m) => m.menuId !== 'M_WorkStop/write');
        } else {
          menuInfo = menuInfo.filter((m) => m.menuId !== 'M_WorkStop');
        }

        // 외부인인 경우 TBM 참석, 작업허가서, 교육일지 메뉴만 보여줌
        if (data.userInfo?.internalYn === '1') {
          menuInfo = menuInfo.filter((m) => INTERNAL_MENU.includes(m.menuId));
        }

        menuInfo.push(
          ...menuInfo,
          {
            no: 0,
            authCd: '',
            authNm: '',
            deleteYn: 'N',
            proId: 'Home',
            menuNm: '홈',
            menuType: '0',
            menuUp: 'Home',
            printYn: 'N',
            saveYn: 'N',
            screenType: '0',
            seq: 0,
            open: false,
          },
          {
            no: 999999,
            authCd: '',
            authNm: '',
            deleteYn: 'N',
            grade: '',
            proId: 'Setting',
            menuId: 'Mypage',
            menuNm: '내정보',
            menuType: '0',
            menuUp: 'Setting',
            printYn: 'N',
            saveYn: 'N',
            screenType: '0',
            seq: 99999999999,
            open: false,
          }
        );

        lanInfo.push(...data.lanInfo);
        custInfo.push(
          ...data.custInfo.map((r) => ({
            ...r,
            name: r.custNm,
            value: r.custCd,
          }))
        );
        companyInfo.push(...data.companyInfo);

        dispatch(BaseInfoActions.setMenuInfo(menuInfo));
        dispatch(BaseInfoActions.setLanInfo(lanInfo));
        dispatch(BaseInfoActions.setCustInfo(custInfo));
        dispatch(BaseInfoActions.setCompanyInfo(companyInfo));

        Commons.Storages('set', 'auth', { auth: true });

        navigate('/Home');
      });
    } catch (e) {
      console.log('Error: ', e);
      setConfirmId(false);
      setConfirmPw(false);
      dispatch(
        showSnackbar({
          message: '아이디와 비밀번호를 확인해주세요.',
          type: 'error',
        })
      );
    } finally {
      setLoading(false);
    }
  };

  // 각 팝업창의 save button 리턴 함수
  const CreateDialogButton = (_type) => {
    switch (_type) {
      case 'SignUp':
        return null;
      case 'identityConfirm':
        return null;
    }
  };

  // 아이디 중복 체크
  const CheckUserId = async () => {
    setLoading(true);

    try {
      // 영문과 숫자만 허용하는 정규식
      const idRegex = /^[a-zA-Z0-9_-]+$/;

      if (signUpInputs.userId === '') {
        setSignUpInputs({
          ...signUpInputs,
          userId: '',
          idDuplicationCheck: false,
          idDuplicationMsg: '아이디를 입력해 주세요.',
        });
      } else if (!idRegex.test(signUpInputs.userId)) {
        setSignUpInputs({
          ...signUpInputs,
          userId: '',
          idDuplicationCheck: false,
          idDuplicationMsg: '영문과 숫자만 입력 가능합니다.',
        });
      } else {
        await Commons.Axios(
          'post',
          Global.base.useUrl + Global.urls.Account.CheckUserId,
          {
            value1: Commons.EncryptAES(signUpInputs.userId),
          }
        ).then((result) => {
          let data = result.data;

          if (data.type === 'Error') {
            throw new Error(data.message);
          } else {
            if (data) {
              setSignUpInputs({
                ...signUpInputs,
                idDuplicationCheck: true,
                idDuplicationMsg: '',
              });
            } else {
              setSignUpInputs({
                ...signUpInputs,
                userId: '',
                idDuplicationCheck: false,
                idDuplicationMsg: '중복된 아이디입니다.',
              });
            }
          }
        });
      }
    } catch (e) {
      console.log('Error: ', e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      setLoading(false);
    }
  };

  // 회원가입 2단계 유효성 검사
  const SignUpIndex2Validation = () => {
    const isExternal = signUpInputs.memberSignUpType === 'EXTERNAL';

    if (!String(signUpInputs.userId || '').trim()) {
      dispatch(
        showSnackbar({
          message: '아이디를 입력해 주세요.',
          type: 'warning',
        })
      );
      return false;
    }

    const omitKeys = new Set(['userId', 'userCustCd']);
    if (isExternal) {
      omitKeys.add('userAddress1');
      omitKeys.add('userAddress2');
      omitKeys.add('userDepCd');
      omitKeys.add('userBlood');
    } else {
      omitKeys.add('affiliationNm');
    }

    const fieldsForValidation = Object.fromEntries(
      Object.entries(Login_Schema.fields.signUpForm).filter(
        ([key]) => !omitKeys.has(key)
      )
    );

    if (
      !validateRequiredWithMessage([signUpInputs], {
        fields: fieldsForValidation,
      })
    ) {
      return false;
    }

    if (isExternal && !String(signUpInputs.affiliationNm || '').trim()) {
      dispatch(
        showSnackbar({
          message: '업체명을 입력해 주세요.',
          type: 'warning',
        })
      );
      return false;
    }

    let passwordRegex = /^(?=.*[A-Za-z])(?=.*\d).{8,}$/;

    if (signUpInputs.userPw !== signUpInputs.userPwConfirm) {
      dispatch(
        showSnackbar({
          message: '비밀번호가 일치하지 않습니다.',
          type: 'warning',
        })
      );
      return false;
    } else if (!passwordRegex.test(signUpInputs.userPw)) {
      dispatch(
        showSnackbar({
          message: '영문, 숫자 포함 8자 이상으로 입력 해주세요.',
          type: 'warning',
        })
      );
      return false;
    }

    return true;
  };

  // 회원가입 — 회사명 검색
  const SearchSignupCompanies = async (
    searchText,
    { silent = false, skipGlobalLoading = false } = {}
  ) => {
    const keyword = String(searchText || '').trim();
    if (!keyword) {
      setSignupCompanyOptions([]);
      if (!silent) {
        dispatch(
          showSnackbar({
            message: '회사명을 입력해 주세요.',
            type: 'warning',
          })
        );
      }
      return [];
    }

    if (!skipGlobalLoading) {
      setLoading(true);
    }
    try {
      const result = await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Account.searchSignupCompanies,
        { SearchText: Commons.EncryptAES(keyword) }
      );
      const data = result.data;

      if (data?.type === 'Error') {
        throw new Error(data.message);
      }

      const companyList = (Array.isArray(data) ? data : []).map((item) => ({
        value: item.coCd,
        name: item.coNm || item.coCd,
      }));

      setSignupCompanyOptions(companyList);

      if (companyList.length === 0 && !silent) {
        dispatch(
          showSnackbar({
            message: '검색 결과가 없습니다. 회사명을 확인해 주세요.',
            type: 'warning',
          })
        );
      }

      return companyList;
    } catch (e) {
      console.log('Error: ', e);
      setSignupCompanyOptions([]);
      if (!silent) {
        setSignupSiteOptions([]);
      }
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
      return [];
    } finally {
      if (!skipGlobalLoading) {
        setLoading(false);
      }
    }
  };

  const ClearSignupCompanySelection = () => {
    setSignupCompanyOptions([]);
    setSignupSiteOptions([]);
    setDeptOptions([]);
  };

  // 회원가입 — 선택 회사의 사업장 목록 조회
  const SearchSignupCustsByCoCd = async (coCd) => {
    if (!coCd) {
      setSignupSiteOptions([]);
      return [];
    }

    setDeptOptions([]);
    setLoading(true);
    try {
      const result = await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Account.getSignupCusts,
        { CoCd: Commons.EncryptAES(coCd) }
      );
      const data = result.data;

      if (data?.type === 'Error') {
        throw new Error(data.message);
      }

      const siteList = (Array.isArray(data) ? data : []).map((item) => ({
        value: item.custCd,
        name: item.custNm || item.custCd,
      }));

      setSignupSiteOptions(siteList);

      if (siteList.length === 0) {
        dispatch(
          showSnackbar({
            message: '선택한 회사에 등록 가능한 사업장이 없습니다.',
            type: 'warning',
          })
        );
      }

      return siteList;
    } catch (e) {
      console.log('Error: ', e);
      setSignupSiteOptions([]);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
      return [];
    } finally {
      setLoading(false);
    }
  };

  // 사업장 선택 시 부서 목록 조회
  const SearchDeptByCustCd = async (custCd) => {
    if (!custCd) {
      dispatch(
        showSnackbar({
          message: '사업장을 먼저 선택해 주세요.',
          type: 'warning',
        })
      );
      return;
    }

    setLoading(true);
    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Account.getDepartments,
        { CustCd: Commons.EncryptAES(custCd) }
      ).then((result) => {
        let data = result.data;

        if (data && data.length > 0) {
          if (data[0].type === 'Error') {
            throw new Error(data[0].message);
          } else {
            const deptList = data.map((item) => ({
              value: item.depCd,
              name: item.depNmLast || item.depCd,
            }));
            setDeptOptions(deptList);
            dispatch(
              showSnackbar({
                message: `${deptList.length}개의 부서를 찾았습니다.`,
                type: 'success',
              })
            );
          }
        } else {
          setDeptOptions([]);
          dispatch(
            showSnackbar({
              message: '부서 정보를 찾을 수 없습니다.',
              type: 'warning',
            })
          );
        }
      });
    } catch (e) {
      console.log('Error: ', e);
      setDeptOptions([]);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      setLoading(false);
    }
  };

  // 회원가입 저장 함수
  const SaveLogic2 = async (_value1, _value2, memberSignUpType) => {
    try {
      const resolvedMemberSignUpType =
        memberSignUpType ?? signUpInputs.memberSignUpType;
      const isExternalSignUp = resolvedMemberSignUpType === 'EXTERNAL';
      const fullAddress = isExternalSignUp
        ? ''
        : `${signUpInputs.userAddress1 || ''} ${
            signUpInputs.userAddress2 || ''
          }`.trim();
      const depCdPayload = isExternalSignUp ? '' : signUpInputs.userDepCd || '';

      const result = await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Account.signUp,
        {
          name: Commons.EncryptAES(signUpInputs.userNm),
          password: Commons.EncryptAES(signUpInputs.userPw),
          id: Commons.EncryptAES(signUpInputs.userId),
          employeeNo: Commons.EncryptAES(signUpInputs.userId),
          tel: Commons.EncryptAES(signUpInputs.userTel),
          birth: Commons.EncryptAES(signUpInputs.userBirth),
          bloodType: Commons.EncryptAES(
            isExternalSignUp ? '' : signUpInputs.userBlood
          ),
          address: Commons.EncryptAES(fullAddress),
          custCd: Commons.EncryptAES(signUpInputs.userCustCd || ''),
          depCd: Commons.EncryptAES(depCdPayload),
          affiliationNm: Commons.EncryptAES(
            isExternalSignUp ? signUpInputs.affiliationNm || '' : ''
          ),
          position: Commons.EncryptAES(signUpInputs.position || ''),
          rank: Commons.EncryptAES(signUpInputs.rank || ''),
          ci: Commons.EncryptAES(signUpInputs.ci || ''),
          di: Commons.EncryptAES(signUpInputs.di || ''),
          issueDate: Commons.EncryptAES(signUpInputs.issueDate || ''),
          issuer: Commons.EncryptAES(signUpInputs.issuer || ''),
          providerId: Commons.EncryptAES(signUpInputs.providerId || ''),
          reqAuthType: Commons.EncryptAES(signUpInputs.reqAuthType || ''),
          reqDate: Commons.EncryptAES(signUpInputs.reqDate || ''),
          serviceType: Commons.EncryptAES(signUpInputs.serviceType || ''),
          siteId: Commons.EncryptAES(signUpInputs.siteId || ''),
          txId: Commons.EncryptAES(signUpInputs.txId || ''),
          gender: Commons.EncryptAES(signUpInputs.userGender || ''),
          foreignerYn: Commons.EncryptAES(signUpInputs.userNation || ''),
          internalYn: Commons.EncryptAES(isExternalSignUp ? '1' : '0'),
        }
      );

      let data = result.data;
      setSignUpId(data.userId);

      if (data) {
        if (data.type === 'Ok') {
          // 프로시저에서 반환된 managerId와 fcmToken을 사용하여 알림 전송
          if (data.managerId && data.fcmToken) {
            // FCM 알림 전송 로직 (필요시 구현)
            // 현재는 프로시저에서 알림을 처리하지 않으므로 주석 처리
          }

          // 성공 메시지
          dispatch(
            showSnackbar({
              message: '회원가입이 완료되었습니다.',
              type: 'success',
            })
          );

          return true; // 성공 시 true 반환
        } else {
          // type이 'Ok'가 아닌 경우 (예: 'Error')
          const errorMessage =
            data.message || '회원가입에 실패했습니다. 다시 시도해주세요.';
          throw new Error(errorMessage);
        }
      } else {
        const errorMessage =
          data.message || '회원가입에 실패했습니다. 다시 시도해주세요.';
        throw new Error(errorMessage);
      }
    } catch (e) {
      console.log('Error: ', e);

      // 아이디·등록코드 중복 등 DB 유니크 위반
      const errorMessage = e.message || '';
      if (
        errorMessage.includes('Duplicate entry') &&
        errorMessage.includes('PRIMARY')
      ) {
        dispatch(
          showSnackbar({
            message: '이미 사용 중인 아이디입니다.',
            type: 'warning',
          })
        );
        return false; // 실패 시 false 반환
      }

      dispatch(showSnackbar({ message: e.message, type: 'error' }));
      return false; // 실패 시 false 반환
    } finally {
      setLoading(false);
    }
  };

  // 임시 비밀번호 발급 → FindPw 성공 화면에 표시
  const SaveLogic4 = async () => {
    setLoading(true);
    try {
      const phoneId = (findPwInputs.userTel || '').replace(/[^0-9]/g, '');
      const userId = findPwInputs.userId || phoneId;
      const result = await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Account.saveTempPassword,
        {
          UserId: Commons.EncryptAES(userId),
        }
      );
      const data = result.data;

      if (data?.type === 'Ok') {
        let tempPassword = '';
        if (data.tempPassword) {
          try {
            tempPassword = Commons.DecryptoAES(data.tempPassword) || '';
          } catch (_) {
            tempPassword = '';
          }
        }

        setFindPwInputs((prev) => ({
          ...prev,
          userId: data.userId,
          userTel: data.userId,
          tempPassword,
          issueMessage: data.message || '임시 비밀번호가 발급되었습니다.',
          successful: true,
          identityErrMsg: '',
        }));
        return true;
      }

      dispatch(
        showSnackbar({
          message: data?.message || '임시 비밀번호 발급에 실패했습니다.',
          type: 'warning',
        })
      );
    } catch (e) {
      console.log('Error: ', e);
      dispatch(
        showSnackbar({
          message: e.message || '임시 비밀번호 발급에 실패했습니다.',
          type: 'error',
        })
      );
      return false;
    } finally {
      setLoading(false);
    }
  };

  // Dialog 닫는 함수
  const CloseDialog = () => {
    setDialog({
      ...dialog,
      open: false,
    });
    setFindPwInputs(createInitial(Login_Schema.fields.findPwForm));
    setSignUpInputs(createInitial(Login_Schema.fields.signUpForm));
    sessionStorage.removeItem(MOK_SIGNUP_CONTEXT_KEY);
    setAgreement(createInitial(Login_Schema.fields.agreement));

    setSiteList([]);
    setSiteManagerSite('');
    setSiteManagerSiteInput('');

    setHeadManagerSite('');
    setHeadManagerSiteInput('');
    setDeptOptions([]);
    setSignupCompanyOptions([]);
    setSignupSiteOptions([]);

    dispatch(CommonActions.resetActiveStep());
  };

  // CapsLock 확인 함수
  const checkCapsLock = (e) => {
    let capsLock = e.getModifierState('CapsLock');
    setCapsLockFlag(capsLock);
  };

  // 사용자가 해당 앱을 설치하지 않았을 경우에만 발생함.
  const HandleBeforeInstallPrompt = (e) => {
    e.preventDefault(); // 이벤트 억제
    setDeferredPrompt(e); // deferredPrompt에 event 객체 저장
  };

  return (
    <div className="Login">
      <Login
        inputs={inputs}
        setInputs={setInputs}
        lanCdList={lanCdList}
        lanList={lanList}
        dialog={dialog}
        setDialog={setDialog}
        ChangeCheckbox={ChangeCheckbox}
        DialogLogic={DialogLogic}
        LoginLogic={LoginLogic}
        sign={sign}
        setSign={setSign}
        imageFile={imageFile}
        setImageFile={setImageFile}
        workSignature={workSignature}
        setWorkSignature={setWorkSignature}
        confirmId={confirmId}
        confirmPw={confirmPw}
      />
      <Loading open={loading} />

      {/* 비밀번호 찾기 — Tailwind 팝업 */}
      <FindPw
        open={dialog.open && dialog.type === 'FindPw'}
        onClose={CloseDialog}
        findPwInputs={findPwInputs}
        setFindPwInputs={setFindPwInputs}
        SaveLogic4={SaveLogic4}
        loading={loading}
      />

      {/* 회원가입/본인인증 화면을 위한 다이얼로그 */}
      <Dialog
        fullWidth
        open={dialog.open && dialog.type !== 'FindPw'}
        onClose={CloseDialog}
        title={
          Commons.IsMobile() && dialog.type === 'SignUp' ? (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              {/* 제목 */}
              <Typography
                sx={{
                  position: 'absolute',
                  left: '16px',
                  fontSize: '20px',
                  fontWeight: 700,
                  lineHeight: '32px',
                  color: '#111827',
                }}
              >
                {dialog.title}
              </Typography>

              {/* 닫기 버튼 */}
              <IconButton
                onClick={CloseDialog}
                sx={{
                  position: 'absolute',
                  right: '16px',
                  color: '#111827',
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          ) : (
            dialog.title
          )
        }
        content={
          dialog.type === 'SignUp' ? (
            <SignUp
              lanList={lanList}
              codeList={codeList}
              signUpInputs={signUpInputs}
              setSignUpInputs={setSignUpInputs}
              listOptions={listOptions}
              agreement={agreement}
              setAgreement={setAgreement}
              authGroups={authGroups}
              regions={regions}
              siteManagerSite={siteManagerSite}
              setSiteManagerSite={setSiteManagerSite}
              siteManagerSiteInput={siteManagerSiteInput}
              setSiteManagerSiteInput={setSiteManagerSiteInput}
              siteList={siteList}
              headManagerSite={headManagerSite}
              setHeadManagerSite={setHeadManagerSite}
              headManagerSiteInput={headManagerSiteInput}
              setHeadManagerSiteInput={setHeadManagerSiteInput}
              custList={custList}
              CheckUserId={CheckUserId}
              SignUpIndex2Validation={SignUpIndex2Validation}
              SaveLogic2={SaveLogic2}
              CloseDialog={CloseDialog}
              modalToggle1={modalToggle1}
              setModalToggle1={setModalToggle1}
              workSignature={workSignature}
              setWorkSignature={setWorkSignature}
              sign={sign}
              setSign={setSign}
              imageFile={imageFile}
              setImageFile={setImageFile}
              capsLockFlag={capsLockFlag}
              setCapsLockFlag={setCapsLockFlag}
              checkCapsLock={checkCapsLock}
              SearchDeptByCustCd={SearchDeptByCustCd}
              SearchSignupCompanies={SearchSignupCompanies}
              SearchSignupCustsByCoCd={SearchSignupCustsByCoCd}
              ClearSignupCompanySelection={ClearSignupCompanySelection}
              signupCompanyOptions={signupCompanyOptions}
              signupSiteOptions={signupSiteOptions}
              deptOptions={deptOptions}
              signUpId={signUpId}
            />
          ) : (
            <IdentityConfirm userId={inputs.userId} />
          )
        }
        actions={CreateDialogButton(dialog.type)}
        closeButtonName={
          lanList.length > 0
            ? lanList.filter((f) => f.lanId === 'Close')[0].lanNm
            : ''
        }
        useCloseButton={dialog.type === 'SignUp' ? false : true}
        fullScreen={Commons.IsMobile() ? true : false}
        maxWidth="sm"
        titleSx={{
          height: `${statusBar + 56}px`,
          width: '100%',
          p: 0,
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          pt: `${statusBar}px`,
        }}
        sx={{ '& .MuiDialog-paper': { margin: 0 } }}
        contentSx={{
          height: `calc(100vh - ${statusBar + navBar}px)`,
          p: 0,
          pb: `${navBar}px`,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }}
        actionsSx={{
          p: 0,
          pb: dialog.type === 'identityConfirm' ? `${navBar + 16}px` : '16px',
        }}
      />
    </div>
  );
}
// 내 인생이 와 글노...
export default LoginFunction;
